/* Trustpilot Product Mini on collection cards.
 * Injected below each Boost card's `.product-size-information`.
 * data-sku gets all variant SKUs. The widget is added only when that
 * SKU list has at least one review.
 */
(function () {
  var TP = {
    template: '54d39695764ea907c0f34825',
    bu:       '5cd91b7ca6237300016f554c',
    token:    '6a5ecfa6-b9a6-4c29-b335-ffea21055c60',
    reviewUrl:'https://uk.trustpilot.com/review/fultonfishmarket.com'
  };

  function skuListFromVariants(variants) {
    if (!variants || !variants.length) return '';
    var seen = {}, out = [];
    for (var i = 0; i < variants.length; i++) {
      var s = variants[i].sku;
      if (!s || seen[s]) continue;
      seen[s] = 1;
      out.push(s);
    }
    return out.join(',');
  }

  var countCache = {};
  function reviewCount(sku) {
    var key = sku.split(',').sort().join(',');
    if (countCache[key]) return countCache[key];
    var url = 'https://widget.trustpilot.com/trustbox-data/' + TP.template +
              '?businessUnitId=' + TP.bu + '&locale=en-GB&sku=' + encodeURIComponent(sku);
    countCache[key] = fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var s = d && d.productReviewsSummary && d.productReviewsSummary.numberOfReviews;
        return s ? s.total : 0;
      })
      .catch(function () { return 0; });
    return countCache[key];
  }

  function buildWidget(sku) {
    var w = document.createElement('div');
    w.className = 'trustpilot-widget tp-card';
    w.setAttribute('data-locale', 'en-GB');
    w.setAttribute('data-template-id', TP.template);
    w.setAttribute('data-businessunit-id', TP.bu);
    w.setAttribute('data-style-height', '24px');
    w.setAttribute('data-style-width', '100%');
    w.setAttribute('data-token', TP.token);
    w.setAttribute('data-sku', sku);
    w.setAttribute('data-no-reviews', 'hide');
    w.setAttribute('data-scroll-to-list', 'true');
    w.setAttribute('data-style-alignment', 'left');
    w.innerHTML = '<a href="' + TP.reviewUrl + '" target="_blank" rel="noopener">Trustpilot</a>';
    return w;
  }

  function ensureBootstrap() {
    return new Promise(function (resolve) {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        resolve(window.Trustpilot);
        return;
      }
      var existing = document.querySelector('script[src*="tp.widget.bootstrap"]');
      if (!existing) {
        existing = document.createElement('script');
        existing.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        existing.async = true;
        document.head.appendChild(existing);
      }
      function ready() {
        return window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function';
      }
      if (ready()) {
        resolve(window.Trustpilot);
        return;
      }
      existing.addEventListener('load', function () {
        resolve(ready() ? window.Trustpilot : null);
      });
      var n = 0;
      var iv = setInterval(function () {
        n++;
        if (ready()) {
          clearInterval(iv);
          resolve(window.Trustpilot);
        } else if (n > 50) {
          clearInterval(iv);
          resolve(null);
        }
      }, 200);
    });
  }

  function tpLoad(el) {
    ensureBootstrap().then(function (Trustpilot) {
      if (Trustpilot) Trustpilot.loadFromElement(el, true);
    });
  }

  var CARD   = '.boost-sd__product-item';
  var ANCHOR = '.product-size-information';
  var LINK   = 'a[href*="/products/"]';
  var skuCache = {};
  var pending  = {};

  function getHandle(card) {
    var a = card.querySelector(LINK);
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function resolveSku(handle) {
    if (skuCache[handle] !== undefined) return Promise.resolve(skuCache[handle]);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var skus = skuListFromVariants(p && p.variants);
        if (!skus) { skuCache[handle] = ''; return ''; }
        return reviewCount(skus).then(function (n) {
          skuCache[handle] = n > 0 ? skus : '';
          return skuCache[handle];
        });
      })
      .catch(function () { skuCache[handle] = ''; return ''; });
    return pending[handle];
  }

  function decorate(card) {
    if (card.querySelector('.tp-card')) return;
    var anchor = card.querySelector(ANCHOR);
    if (!anchor) return;
    var handle = getHandle(card);
    if (!handle) return;
    resolveSku(handle).then(function (sku) {
      if (!sku || card.querySelector('.tp-card')) return;
      var w = buildWidget(sku);
      anchor.insertAdjacentElement('afterend', w);
      tpLoad(w);
    });
  }

  function run() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) decorate(cards[i]);
  }

  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
    .observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
